import React from 'react';
import TextField from '@mui/material/TextField';

function NumberDaysEdit(params) {
    return (
        <TextField
            type="number"
            value={params.value ?? ''}
            onChange={(e) => {
                const numberValue = Number(e.target.value);
                const newValue =
          numberValue < 0 ? 0 : numberValue > 999 ? 999 : numberValue;
                params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: newValue ? String(newValue) : '',
                });
            }}
            onKeyDown={(e) => {
                const allowed = [
                    'Backspace',
                    'Delete',
                    'ArrowLeft',
                    'ArrowRight',
                    'Tab',
                    'Enter',
                ];
                if (allowed.includes(e.key)) return;
                if (!/^[0-9]$/.test(e.key)) {
                    e.preventDefault();
                }
            }}
            variant="standard"
            size="small"
            fullWidth
            slotProps={{
                htmlInput: {
                    min: 0,
                    max: 999,
                    step: 1,
                    inputMode: 'numeric', // helps mobile keyboard
                    style: { textAlign: 'right', height: '100%' },
                },
            }}
            sx={{
                height: '100%',
                '& .MuiInputBase-root': {
                    height: '100%',
                    alignItems: 'center',
                    padding: 0,
                },
                '& .MuiInputBase-input': {
                    height: '100%',
                    padding: '0 12px 0 0',
                    boxSizing: 'border-box',
                },
                // hide spinners
                '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button':
          {
              WebkitAppearance: 'none',
              margin: 0,
          },
                '& input[type="number"]': {
                    MozAppearance: 'textfield',
                },
            }}
            autoFocus
        />
    );
}

export default NumberDaysEdit;
